export default [
    {
        value: "LaboratorioNovoEnsinoSuperior",
        text: "Laboratório novo em instituição de ensino superior"
    },
    {
        value: "LaboratorioExistenteEnsinoSuperior",
        text: "Laboratório existente em instituição de ensino superior"
    },
    {
        value: "LaboratorioNovoInstituicaoPesquisa",
        text: "Laboratório novo em instituição de pesquisa"
    },
    {
        value: "LaboratorioExistenteInstituicaoPesquisa",
        text: "Laboratório existente em instituição de pesquisa"
    },
    {
        value: "LaboratorioNovoEmpresaEnergiaEletrica",
        text: "Laboratório novo em empresa de energia elétrica"
    },
    {
        value: "LaboratorioExistenteEmpresaEnergiaEletrica",
        text: "Laboratório existente em empresa de energia elétrica"
    },
]